import { Pipe, PipeTransform } from '@angular/core';
import {  PLANS_HELPER } from '@oneqrew-partnertool/utils';

@Pipe({
  name: 'basicModuleText'
})
export class BasicModuleTextPipe implements PipeTransform {
  transform(packageType: string): string {
    return PLANS_HELPER.isL_PAKET(packageType) ? 'inkl. 1. Arbeitsplatz und 2 mobile Geräte' : 'inkl. 1. Arbeitsplatz';
  }
}
